import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Location } from "../../../@types/location";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const findLocations = createAsyncThunk(
  "templateDetail/findLocations",
  async (id, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const { data } = await axiosInstance.get(`${api.baseURL}location`, {
        params: {
          // where: { usersCount: { ">=": 1 } },
          limit: 10000,
          sort: "name ASC",
          where: {
            sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          }
        },
      });
      return data as Location[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
